import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import EmptyState from 'components/reusables/emptyState'
import { AccessToLearningProgramsEnum } from 'enum/accessToLearningPrograms'
import { useRolesAndPermissions } from '../../../context/RolesAndPermissionsContext'
import { Container, Header, Title, Content, Alert } from './styled'
import LearningPrograms from './learningPrograms'
import AddLearningPrograms from './addLearningPrograms'

const AccessToLearningPrograms = () => {
  const { t } = useTranslation()
  const { roleDetail: data } = useRolesAndPermissions()
  const isPermissionsDisabled = data.isDefault
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToLearningPrograms'
  const [isOpen, setIsOpen] = useState(true)
  const [showAddLearningProgram, setShowAddLearningProgram] = useState(false)

  return (
    <Container>
      <Header onClick={() => setIsOpen(!isOpen)}>
        <Button type="link">
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </Button>
        <Title>{t(`${prefix}.title`)}</Title>
      </Header>
      <Content open={isOpen} disabled={isPermissionsDisabled}>
        <Alert>
          <FontAwesomeIcon icon={faInfoCircle as IconProp} />
          {t(`${prefix}.alert`)}
        </Alert>
        {data.accessToLearningPrograms ===
          AccessToLearningProgramsEnum.None && (
          <EmptyState
            title={t(`${prefix}.emptyState.title`)}
            icon={faGraduationCap as IconProp}
            iconSize="small"
            action={() => setShowAddLearningProgram(true)}
            actionTitle={t(`${prefix}.emptyState.action`)}
            actionIcon={faPlus as IconProp}
            actionDisabled={isPermissionsDisabled}
          />
        )}
        {data.accessToLearningPrograms === AccessToLearningProgramsEnum.All && (
          <EmptyState
            title={t(`${prefix}.allLearningPrograms.title`)}
            icon={faGraduationCap as IconProp}
            iconBackground="#CFE7FD"
            iconColor="#213F68"
            iconSize="small"
            action={() => setShowAddLearningProgram(true)}
            actionTitle={t(`${prefix}.allLearningPrograms.action`)}
            actionIcon={faPlus as IconProp}
            actionDisabled={isPermissionsDisabled}
          />
        )}
        {data.accessToLearningPrograms ===
          AccessToLearningProgramsEnum.Specific && (
          <LearningPrograms
            addLearningProgram={() => setShowAddLearningProgram(true)}
            disabled={isPermissionsDisabled}
          />
        )}
      </Content>
      {showAddLearningProgram && !isPermissionsDisabled && (
        <AddLearningPrograms close={() => setShowAddLearningProgram(false)} />
      )}
    </Container>
  )
}

export default AccessToLearningPrograms
